export default __webpack_public_path__ + "static/media/bannerDarkBackgroundImg.0e33e718.png";